import {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
} from "@/lobby_common/utils/auth.js";
import store from "@/lobby_common/store";
import { getHomepage } from "@/lobby_common/cdnApi";
import {
  resMenuList,
  getCarouselTemplate,
} from "@/lobby_common/api/basic_gen.js";

// 缓存数据
const cacheFun = async (fun, data, key) => {
  const templateLastUpdateTime =
    store.getters.getPacketDomain?.templateLastUpdateTime; // 模版更新时间
  const lang = getLocalStorage("lang")?.lang; // 语言
  let cacheApiData = getLocalStorage(key) || {}; // 缓存的数据
  const localUserCreateType = getLocalStorage("localUserType") || null; // 缓存的用户类型

  // 配置变更，切换语言，清除缓存
  if (
    Number(templateLastUpdateTime) >
      Number(cacheApiData?.cache_templateLastUpdateTime) ||
    cacheApiData?.cache_lang !== lang ||
    cacheApiData?.cache_localUserCreateType !== localUserCreateType
  ) {
    removeLocalStorage(key);
    cacheApiData = {};
  }
  let res = cacheApiData;
  if (res?.code === 0) {
    return res;
  }
  res = await fun(data);
  if (res.code === 0) {
    setLocalStorage(key, {
      ...res,
      cache_lang: lang,
      cache_templateLastUpdateTime: templateLastUpdateTime,
      cache_localUserCreateType: localUserCreateType,
    });
  }
  return res;
};

const getKey = (initKey) => {
  const isLogin = store.getters.taken;
  if (isLogin) {
    return initKey + "_isLogin";
  } else {
    return initKey + "_noLogin";
  }
};

// 首页模版
export const getHomepageC = async (data) => {
  let key = getKey("homePage");
  if (data?.sid) {
    // 副首页
    // key = getKey("viceHomePage");
    return getViceHomePage(data.sid);
  }
  return await cacheFun(getHomepage, data, key);
};

export const saveViceHomePage = (id, data) => {
  const KEY = 'viceHomePage';
  let list = getLocalStorage(KEY) || [];
  console.log('list=>', list, data);

  // 去重：如果已有该 id 先删除旧的
  list = list.filter(item => item.id !== id);

  // 插入最新的到最前面
  list.unshift({ id, data });

  // 超过 3 条，删除最后一条
  if (list.length > 3) {
    list.pop();
  }
  setLocalStorage(KEY, list);
}

export const clearViceHomePage = (id, data) => {
  const KEY = 'viceHomePage';
  removeLocalStorage(KEY);
}

export const getViceHomePage = (id) => {
  const KEY = 'viceHomePage';
  const list = getLocalStorage(KEY) || [];
  const item = list.find(item => item.id === id);
  return item ? item.data : null;
}

// 菜单列表
export const resMenuListC = async (data) => {
  const key = getKey("menu");
  return await cacheFun(resMenuList, data, key);
};

// 轮播图
export const getCarouselTemplateC = async (data) => {
  const key = getKey("banner");
  return await cacheFun(getCarouselTemplate, data, key);
};
